function setPriceAttributes() {
  const sections = document.querySelectorAll(
    ".upcart-products-section .upcart-product-item"
  );

  sections.forEach((section) => {
    const id = section.id;
    const priceElement = section.querySelector(".upcart-item-price");
    if (priceElement) {
      priceElement.setAttribute("bss-b2b-cart-item-key", id);
      priceElement.setAttribute("bss-b2b-final-line-price", "");

      // fix QB
      priceElement.classList.add('cart-item-price')
    }
    // fix QB
    section.setAttribute("data-cart-item-key", id);
  });
}

function setLinkAtribute() {
  var link = document.querySelector(".upcart-checkout-button-container a");
  if (link) {
    link.innerHTML = "Checkout <span bss-b2b-cart-total-price></span>";
  }
}

setTimeout(setLinkAtribute, 500);
setTimeout(setPriceAttributes, 500);

setTimeout(() => {
  const btns = document.querySelectorAll(".upcart-products-section");

  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        setPriceAttributes();
        setLinkAtribute();
      }, 1000);
    });
  });
}, 500);

setTimeout(() => {
  const cartAjax = document.querySelector("#CartPopup");
  if (cartAjax) {
    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          setTimeout(() => {
            setPriceAttributes();
            setLinkAtribute();
            BSS_B2B.cart.fixer(
              JSON.parse($("#bss-b2b-store-data").html()),
              false,
              false
            );
          }, 2000);
        }
      }
    };
    const observer = new MutationObserver(callback);
    const config = { attributes: true };
    observer.observe(cartAjax, config);
  }
}, 500);
